
import { call, put, select } from 'redux-saga/effects'
import request from '@src/utility/request'
import {
    loadReceiptSuccess,
    loadReceiptFail
} from '../../actions/trackandtrace'
import {
    selectBaseUrl,
    selectLocale
} from '../../selectors/config'
import {
    selectToken
} from '../../selectors/auth'


// worker Saga: will be fired on TABLE_LOAD_DATA action
export function* fetchReceipt(params) {
    const { receiptId } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = 'stepAssigned'
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${receiptId}`, requestOptions)
        
        if (res.data) {
            
            yield put(loadReceiptSuccess(res.data))

        } else {
            yield put(loadReceiptFail(receiptId, res.data))
        }
      
    } catch (e) {
       yield put(loadReceiptFail(receiptId, [{message: e.message}]))
    }
}